import { c as _c } from "react/compiler-runtime";
import { Box, Button, VStack } from '@chakra-ui/react';
import { useParentAppLayout } from '@src/components/sco/AppLayout/AppLayoutContext.tsx';
import { AppLayoutToolbar } from '@src/components/sco/AppLayout/Toolbar/AppLayoutToolbar.tsx';
import React, { ReactNode } from 'react';
type AccountMainPanelProps = {
  children: ReactNode | ReactNode[];
};
export const AccountMainPanel = props => {
  const $ = _c(7);
  const layout = useParentAppLayout();
  let t0;
  if ($[0] !== layout) {
    t0 = <AppLayoutToolbar rightElements={<Button borderRadius="full" size="sm" variant="outline" onClick={() => {
      layout.togglePanel("account-aside");
    }}>Need Help?</Button>} />;
    $[0] = layout;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.children) {
    t1 = <Box height="full" overflowY="auto">{props.children}</Box>;
    $[2] = props.children;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <VStack align="stretch" alignSelf="stretch" gap={0} height="full" justify="stretch" justifySelf="stretch" maxHeight="100%" width="full">{t0}{t1}</VStack>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};